import { Share2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButton = ({ name }) => {
  const share = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title: name, text: `${name} disponibile su MC Anime!`, url });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiato negli appunti!");
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };
  return (
    <button data-testid="product-share-button" aria-label="Condividi" className="btn-ghost-mc !px-3.5 !py-3" onClick={share}>
      <Share2 className="h-5 w-5" /> <span className="hidden sm:inline">Condividi</span>
    </button>
  );
};
